module.exports = __webpack_public_path__ + "static/media/huisjein.92fa85da.jpg";